import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

import {
  ShiftReference,
  WorkLoadAgentsShiftsAttendanceModel
} from "../../models/work-load-agents-shifts-attendance.model";

export class WorkloadToolbarPanelComponent implements IController {

  data: WorkLoadAgentsShiftsAttendanceModel[];

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    this.data.forEach((d: WorkLoadAgentsShiftsAttendanceModel) => {

      if (!d.shifts) {
        d.shifts =[];
      }

      d.shifts = d.shifts.sort(function compare(a: ShiftReference, b: ShiftReference) {
        return a.shiftStartTime - b.shiftStartTime;
      })
    })

    this.data = this.data.sort(function compare(a: WorkLoadAgentsShiftsAttendanceModel, b: WorkLoadAgentsShiftsAttendanceModel) {
      return _.get(a.shifts, '[0].shiftStartTime', 0) - _.get(b.shifts, '[0].shiftStartTime', 0);
    })

  }

}

angular
  .module('bringoz.admin.workload')
  .component('workloadToolbarPanel', {
    bindings: {
      data: '<'
    },
    template: require('./workload-toolbar-panel.html').default,
    controller: WorkloadToolbarPanelComponent
  });
